<template>
  <div class="compound public-content">
    <div class="breadcrumb">素材标签管理</div>
    <div class="add-category">
      <div class="keywords">
        <span style="margin:0 10px 0 0">素材标签:</span>
        <el-input v-model="searchLabelVo.label" placeholder="请输入素材标签" clearable></el-input>
        <span style="margin:0 10px 0 15px">标签所属:</span>
        <el-select clearable v-model="searchLabelVo.labelBelongCode" placeholder="请选择">
          <el-option label="" value="">全部</el-option>
          <el-option label="元素" value="ELEM"></el-option>
          <el-option label="背景" value="BG"></el-option>
          <el-option label="组合" value="COMBO"></el-option>
        </el-select>
      </div>
      <div>
        <el-button round @click="queryInfo.pageNum = 1, onSubmit()">查询</el-button>
        <el-button round type="primary" v-permission="'pts:admin:label:add'" @click="selectedTag = [], editId = '', dialogVisible = true"> 新建素材标签</el-button>
      </div>
    </div>
    <div class="right-main">
      <div class="data-list">
        <el-table :data="tableData" border>
          <el-table-column label="素材标签" prop="label"></el-table-column>
          <el-table-column label="标签所属" prop="labelBelong"></el-table-column>
          <el-table-column label="是否合成" prop="needRender">
            <template v-slot="scope"> {{ scope.row.needRender == 1 ? '是' : '否' }} </template>
          </el-table-column>
          <el-table-column label="前端是否显示" prop="isShow">
            <template v-slot="scope">
              <el-switch v-model="scope.row.isShow" :active-value='1' :inactive-value='0' active-color="rgba(20, 115, 230, 1)" inactive-color="rgba(140, 140, 140, 1)"
                @change="changeIsShow(scope.row)">
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template v-slot="scope">
              <span class="color-blue" v-permission="'pts:admin:label:update'" @click="edit(scope.row)">编辑</span><br>
              <span class="color-blue" v-permission="'pts:admin:label:batchRemove'" @click="deleteId = scope.row.id, deleteDialog = true">删除</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!--    分页-->
    <v-pagination class="v-pagination" :queryInfo="queryInfo" v-if="queryInfo.total !== ''" @changePage="changePage"></v-pagination>
    <!-- 新建/编辑标签 -->
    <el-dialog :close-on-click-modal="false" title="标签设置" :visible.sync="dialogVisible" width="30%" @closed='closed'>
      <el-form ref="form" hide-required-asterisk :rules="createRules" :model="labelVo" label-width="120px">
        <el-form-item label="素材标签:" prop="label">
          <el-input v-model="labelVo.label" placeholder="长度最多10" maxlength="10"></el-input>
        </el-form-item>
        <el-form-item label="标签所属:" prop="selectedTag">
          <el-checkbox-group v-model="selectedTag">
            <el-checkbox label="元素" key="ELEM"></el-checkbox>
            <el-checkbox label="背景" key="BG"></el-checkbox>
            <el-checkbox label="组合" key="COMBO"></el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="是否合成:" prop="needRender">
          <el-radio-group v-model="labelVo.needRender">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="前端是否显示:" prop="isShow">
          <el-switch v-model="labelVo.isShow" :active-value='1' :inactive-value='0' active-color="rgba(20, 115, 230, 1)" inactive-color="rgba(140, 140, 140, 1)">
          </el-switch>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="add">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 删除确认 -->
    <el-dialog :close-on-click-modal="false" title="确认" :visible.sync="deleteDialog" width="30%">
      <span>确认删除该素材标签？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteDialog = false">取 消</el-button>
        <el-button type="primary" @click="deleteTag(deleteId)">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
 <script>
import VPagination from '@/components/Pagination/index'
import { labelGetLabelList, labelBatchRemove, labelUpdate, labelAdd } from '@/api/pms'
export default {
  name: 'compound',
  components: {
    VPagination
  },
  data () {
    var checkTag = (rule, value, callback) => {
      if (this.selectedTag.length === 0) {
        callback(new Error('请选择标签所属'))
      } else {
        callback()
      }
    }
    return {
      deleteId: '',
      deleteDialog: false,
      checkedCities: [],
      form: {},
      dialogVisible: false,
      composeList: [],
      keywords: '',
      queryInfo: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      compoundType: [],
      tableData: [{
      }],
      editId: '',
      searchLabelVo: {
        label: '',
        labelBelong: '',
        labelBelongCode: '',
        page: 1
      },
      labelVo: {
        label: '',
        labelBelong: [],
        labelBelongCode: [],
        needRender: 1,
        isShow: 1
      },
      selectedTag: [],
      createRules: {
        label: [
          { required: true, message: '请输入素材标签', trigger: 'blur' }
        ],
        selectedTag: [
          { validator: checkTag, trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    this.onSubmit()
  },
  methods: {
    closed () {
      this.labelVo = {
        label: '',
        labelBelong: [],
        labelBelongCode: [],
        needRender: 1,
        isShow: 1
      }
    },
    edit (row) {
      this.selectedTag = row.labelBelong.split('、')
      this.labelVo.label = row.label
      this.labelVo.needRender = row.needRender
      this.labelVo.isShow = row.isShow
      this.editId = row.id
      this.dialogVisible = true
    },
    // 列表中改变状态
    changeIsShow (row) {
      console.log('row', row)
      labelUpdate(row).then(res => {
        if (res.data.success) {
          this.$message.success('修改成功')
          this.onSubmit()
          this.dialogVisible = false
        }
      })
    },
    add () {
      this.$refs.form.validate(valid => {
        if (!valid) {
          return
        }
        let labelVo = JSON.parse(JSON.stringify(this.labelVo))
        this.selectedTag.forEach(item => {
          labelVo.labelBelong.push(item)
          labelVo.labelBelongCode.push(item === '元素' ? 'ELEM'
            : item === '背景' ? 'BG'
              : item === '组合' ? 'COMBO' : '')
        })
        labelVo.labelBelong = labelVo.labelBelong.join('、')
        labelVo.labelBelongCode = labelVo.labelBelongCode.join(',')
        if (this.editId === '') {
          labelAdd(labelVo).then(res => {
            if (res.data.success) {
              this.$message.success('添加成功')
              this.onSubmit()
              this.dialogVisible = false
            }
          })
        } else {
          labelUpdate({ id: this.editId, ...labelVo }).then(res => {
            if (res.data.success) {
              this.$message.success('修改成功')
              this.onSubmit()
              this.dialogVisible = false
            }
          })
        }
      })
    },
    deleteTag (id) {
      labelBatchRemove([id]).then(res => {
        if (res.data.success) {
          this.$message.success('删除成功')
          this.onSubmit()
          this.deleteDialog = false
        }
      })
    },
    onSubmit () {
      labelGetLabelList({ pageNum: this.queryInfo.pageNum, pageSize: this.queryInfo.pageSize, searchLabelVo: this.searchLabelVo }).then(res => {
        if (res.data.success) {
          if (res.data.data.records.length === 0 && res.data.data.total !== 0 && this.queryInfo.pageNum !== 1) {
            this.queryInfo.pageNum--
            this.onSubmit(this.queryInfo)
          }
          this.tableData = res.data.data.records
          this.queryInfo.total = res.data.data.total
        }
      })
    },
    changePage (val) {
      this.queryInfo = val
      this.onSubmit()
    }
  }
}
</script>
 <style scoped lang="less">
 .compound {
   .add-category {
     justify-content: space-between;
   }
 
   .keywords {
     display: flex;
     justify-content: space-around;
     // width: 750px;
     align-items: center;
 
     .el-input {
       width: 180px;
     }
   }
 }
 </style>
